import React from "react"
import { SortIcon } from "components/Table_SortColumnIcon"
import { getFormattedTime } from "utils"

const formBuilderResponsesListColumns = ({
  displayAnswersColumn,
  openModal,
}) => {
  const defaultColumns = [
    {
      text: "id",
      dataField: "answer_id",
      sort: true,
      hidden: true,
      formatter: (cellContent, item) => <>{item?.answer_id}</>,
    },
    {
      text: "Name",
      dataField: "name",
      formatter: (cellContent, item) => <>{item?.name}</>,
    },
    {
      text: "Email",
      dataField: "email",
      formatter: (cellContent, item) => <>{item?.email}</>,
    },
    {
      text: "Date/Time Submitted",
      dataField: "created_at",
      // sort: true,
      // sortCaret: order => <SortIcon order={order} />,
      formatter: (cellContent, item) => (
        <>
          {item?.created_at?.date
            ? getFormattedTime(item?.created_at?.date)
            : "-"}
        </>
      ),
    },
  ]
  if (displayAnswersColumn) {
    defaultColumns?.push({
      text: "Answers",
      dataField: "answer",
      isDummyField: true,
      formatter: (cellContent, item) => (
        <span
          className="btn-link"
          style={{ cursor: "pointer" }}
          onClick={() => openModal(item)}
        >
          {!item?.stripe_payment
            ? "View Answers"
            : "View answers & payment details"}
        </span>
      ),
    })
  }

  return defaultColumns
}

export default formBuilderResponsesListColumns
